<ul class="price-totals">
    <li class="price-item"><span>Repair Total</span><span class="fs-3">{{ repairTotal|currency }}</span></li>
    <li class="price-item"><span>Deductible</span><span class="fs-3">{{ dollarTotals.deductible|currency }}</span></li>
    <li class="price-line"></li>
    <li class="price-item"><span>Subtotal</span><span class="fs-3">{{ dollarTotals.subTotal | currency }}</span></li>
    <li class="price-spacer"></li>
    <li class="price-item"><span>{{ claimDto.tax!.label }}</span><span class="fs-3">{{ dollarTotals.tax|currency }}</span></li>
    <li class="price-line"></li>
    <li class="price-item"><span class="fw-bold {{claimTotalCssClass}}">Total</span><span class="fs-2 {{claimTotalCssClass}}">{{ dollarTotals.total|currency }}</span></li>
</ul>